export const OWL_VIT_MODEL_NAME = 'AutoBox OWL-ViT'
